import { render, staticRenderFns } from "./ModelosRelatorioDialog.vue?vue&type=template&id=7b1f1c30"
import script from "./ModelosRelatorioDialog.vue?vue&type=script&lang=js"
export * from "./ModelosRelatorioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports